
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogue/[category]",
      function () {
        return require("private-next-pages/catalogue/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalogue/[category]"])
      });
    }
  